"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const FieldsSetupFlowController_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/controllers/FieldsSetupFlowController"));
const GisFilesSummaryTable_vue_1 = __importDefault(require("../components/GisFilesSummaryTable.vue"));
const StepHeader_vue_1 = __importDefault(require("../components/StepHeader.vue"));
const StepFooter_vue_1 = __importDefault(require("../components/StepFooter.vue"));
const AssignmentMetadataAlert_vue_1 = __importDefault(require("../components/AssignmentMetadataAlert.vue"));
let GisFilesSummaryStep = class GisFilesSummaryStep extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.MAIN_CONTROLLER = FieldsSetupFlowController_1.default.getInstance();
        this.STEP_CONTROLLER = this.MAIN_CONTROLLER.filesSummaryStep;
        this.NEXT_STEP_CONTROLLER = this.MAIN_CONTROLLER.fieldsPreviewTableStep;
        this.BEFORE_STEP = this.MAIN_CONTROLLER.workflowStep;
        this.hasWarningModalMetadata = false;
    }
    dismissModal() {
        this.hasWarningModalMetadata = false;
    }
    get uploadFiles() {
        return this.STEP_CONTROLLER.data.files;
    }
    sendFiles() {
        if (this.STEP_CONTROLLER.data.files.every(file => file.assignmentFieldNameCompleted)) {
            this.goNextStep();
        }
        else {
            this.hasWarningModalMetadata = true;
        }
    }
    goNextStep() {
        this.STEP_CONTROLLER.data.fieldsProcessed.forEach(field => {
            if (!field.farmName.length) {
                field.setFarmName(field.origin);
            }
        });
        this.NEXT_STEP_CONTROLLER.addFields(this.STEP_CONTROLLER.data.fieldsProcessed);
        this.MAIN_CONTROLLER.setCurrentStep(this.NEXT_STEP_CONTROLLER);
        let mode = (this.MAIN_CONTROLLER.isAddingFields) ? 'Edition' : 'Setup';
        this.MAIN_CONTROLLER.logActivity({
            'name': `Farm ${mode} Step 2 Completed: Field Selection`,
            'status': 'ok',
            'props': {
                'workflow': 'files'
            }
        });
    }
    beforeStep() {
        this.STEP_CONTROLLER.resetStep();
        this.NEXT_STEP_CONTROLLER.resetStep();
        this.MAIN_CONTROLLER.setCurrentStep(this.BEFORE_STEP);
    }
};
GisFilesSummaryStep = __decorate([
    (0, vue_property_decorator_1.Options)({ components: { GisFilesSummaryTable: GisFilesSummaryTable_vue_1.default, StepFooter: StepFooter_vue_1.default, StepHeader: StepHeader_vue_1.default, AssignmentMetadataAlert: AssignmentMetadataAlert_vue_1.default } })
], GisFilesSummaryStep);
exports.default = GisFilesSummaryStep;
